<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>添加新网账户</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" :model="form" label-width="80px" v-loading="loading">
        <div class="pageSerch">
          <el-card class="box-card" shadow="never">
            <div style="margin-bottom: 15px">
              <span style="font-weight: 600; font-size: 20px">基本信息</span>
            </div>
            <el-form-item label="营业执照照片" label-width="150">
              <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :headers="deader"
                :show-file-list="false"
                accept="image/*"
                :on-success="handleAvatarSuccess"
                v-if="disable == false"
              >
                <img
                  v-if="form.url"
                  :src="form.url"
                  class="avatar"
                  style="width: 100px"
                />
                <div class="modelView1" v-if="form.url">编辑</div>
                <el-button v-else type="primary" style="margin: 0 auto 0"
                  >上传附件</el-button
                >
              </el-upload>
              <el-image
                v-else
                style="width: 150px; height: 100px"
                :src="form.url"
                alt=""
                :preview-src-list="[form.url]"
              ></el-image>
            </el-form-item>
            <div style="display: flex; justify-content: space-between">
              <div style="width: 40%">
                <el-form-item label="企业全称" label-width="150">
                  <el-input v-model="form.name" :disabled="disable"></el-input>
                </el-form-item>
                <el-form-item label="经营证件类型" label-width="150">
                  <el-input v-model="form.type" :disabled="disable"></el-input>
                </el-form-item>
                <el-form-item label="营业执照号码" label-width="150">
                  <el-input v-model="form.num" :disabled="disable"></el-input>
                </el-form-item>
                <el-form-item label="行业代码" label-width="150">
                  <el-input v-model="form.code" :disabled="disable"></el-input>
                </el-form-item>
                <el-form-item label="实际经营地址" label-width="150">
                  <el-input
                    v-model="form.address"
                    :disabled="disable"
                  ></el-input>
                </el-form-item>
              </div>
              <div style="width: 40%">
                <el-form-item label="对公户开户行名称" label-width="150">
                  <el-input
                    v-model="form.bankName"
                    :disabled="disable"
                  ></el-input>
                </el-form-item>
                <el-form-item label="对公户开户行号码" label-width="150">
                  <el-input
                    v-model="form.bankNum"
                    :disabled="disable"
                  ></el-input>
                </el-form-item>
                <el-form-item label="企业对公账户号" label-width="150">
                  <el-input
                    v-model="form.bankNum1"
                    :disabled="disable"
                  ></el-input>
                </el-form-item>
                <el-form-item label="账户名称" label-width="150">
                  <el-input
                    v-model="form.balanceName"
                    :disabled="disable"
                  ></el-input>
                </el-form-item>
                <el-form-item label="账户说明" label-width="150">
                  <el-input
                    v-model="form.balanceMark"
                    :disabled="disable"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </el-card>
          <el-card class="box-card" shadow="never" style="margin: 10px 0">
            <div style="display: flex; justify-content: space-between">
              <div style="width: 40%">
                <div style="margin-bottom: 15px">
                  <span style="font-weight: 600; font-size: 20px"
                    >法人信息</span
                  >
                </div>
                <el-form-item label="法人身份证照片" label-width="150">
                  <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :headers="deader"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess1"
                    v-if="disable == false"
                    accept="image/*"
                  >
                    <img
                      v-if="form.url1"
                      :src="form.url1"
                      class="avatar"
                      style="width: 100px"
                    />
                    <div class="modelView1" v-if="form.url1">编辑</div>
                    <el-button v-else type="primary" style="margin: 0 auto 0"
                      >身份证正面照</el-button
                    >
                  </el-upload>
                  <el-image
                    v-else
                    style="width: 150px; height: 100px"
                    :src="form.url1"
                    alt=""
                    :preview-src-list="[form.url1]"
                  ></el-image>
                  <el-upload
                    class="avatar-uploader"
                    accept="image/*"
                    :action="uploadUrl"
                    :headers="deader"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess2"
                    style="margin-left: 10px"
                    v-if="disable == false"
                  >
                    <img
                      v-if="form.url2"
                      :src="form.url2"
                      class="avatar"
                      style="width: 100px"
                    />
                    <div class="modelView1" v-if="form.url2">编辑</div>
                    <el-button v-else type="primary" style="margin: 0 auto 0"
                      >身份证反面照</el-button
                    >
                  </el-upload>
                  <el-image
                    v-else
                    style="width: 150px; height: 100px; margin-left: 10px"
                    :src="form.url2"
                    alt=""
                    :preview-src-list="[form.url2]"
                  ></el-image>
                </el-form-item>
                <el-form-item label="法人姓名" label-width="150">
                  <el-input v-model="form.name1" :disabled="disable"></el-input>
                </el-form-item>
                <el-form-item label="法人证件类型" label-width="150">
                  <el-input v-model="form.type1" :disabled="disable"></el-input>
                </el-form-item>
                <el-form-item label="法人身份证号" label-width="150">
                  <el-input
                    v-model="form.Idcard"
                    :disabled="disable"
                  ></el-input>
                </el-form-item>
                <el-form-item label="法人手机号" label-width="150">
                  <el-input v-model="form.phone" :disabled="disable"></el-input>
                </el-form-item>
              </div>
              <div style="width: 40%">
                <div style="margin-bottom: 15px">
                  <span style="font-weight: 600; font-size: 20px"
                    >联系人信息</span
                  >
                </div>
                <el-form-item label="联系人身份证照片" label-width="150">
                  <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :headers="deader"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess3"
                    v-if="disable == false"
                    accept="image/*"
                  >
                    <img
                      v-if="form.url3"
                      :src="form.url3"
                      class="avatar"
                      style="width: 100px"
                    />
                    <div class="modelView1" v-if="form.url3">编辑</div>
                    <el-button v-else type="primary" style="margin: 0 auto 0"
                      >身份证正面照</el-button
                    >
                  </el-upload>
                  <el-image
                    v-else
                    style="width: 150px; height: 100px"
                    :src="form.url3"
                    alt=""
                    :preview-src-list="[form.url3]"
                  ></el-image>
                  <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :headers="deader"
                    accept="image/*"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess4"
                    style="margin-left: 10px"
                    v-if="disable == false"
                  >
                    <img
                      v-if="form.url4"
                      :src="form.url4"
                      class="avatar"
                      style="width: 100px"
                    />
                    <div class="modelView1" v-if="form.url4">编辑</div>
                    <el-button v-else type="primary" style="margin: 0 auto 0"
                      >身份证反面照</el-button
                    >
                  </el-upload>
                  <el-image
                    v-else
                    style="width: 150px; height: 100px; margin-left: 10px"
                    :src="form.url4"
                    alt=""
                    :preview-src-list="[form.url4]"
                  ></el-image>
                </el-form-item>
                <el-form-item label="联系人姓名" label-width="150">
                  <el-input v-model="form.name2" :disabled="disable"></el-input>
                </el-form-item>
                <el-form-item label="联系人证件类型" label-width="150">
                  <el-input v-model="form.type2" :disabled="disable"></el-input>
                </el-form-item>
                <el-form-item label="联系人身份证号" label-width="150">
                  <el-input
                    v-model="form.Idcard2"
                    :disabled="disable"
                  ></el-input>
                </el-form-item>
                <el-form-item label="联系人手机号" label-width="150">
                  <el-input
                    v-model="form.phone2"
                    :disabled="disable"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </el-card>
          <el-card class="box-card" shadow="never">
            <div style="display: flex; justify-content: space-between">
              <div style="width: 40%">
                <div
                  v-for="(item, index) in form.enterpriseBeneficiaryInfos"
                  :key="index"
                >
                  <div style="margin-bottom: 15px">
                    <span style="font-weight: 600; font-size: 20px"
                      >最终收益人信息({{ index + 1 }})</span
                    >
                  </div>
                  <el-form-item label="企业最终受益人名称" label-width="150">
                    <el-input
                      v-model="item.enterpriseBeneficiaryName"
                      :disabled="disable"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="企业最终受益人证件类型"
                    label-width="150"
                  >
                    <el-input
                      v-model="item.enterpriseBeneficiaryIdCardType"
                      :disabled="disable"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="企业最终受益人证件号码"
                    label-width="150"
                  >
                    <el-input
                      v-model="item.enterpriseBeneficiaryIdCardNo"
                      :disabled="disable"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="企业最终受益人联系电话"
                    label-width="150"
                  >
                    <el-input
                      v-model="item.enterpriseBeneficiaryIdContactPhone"
                      :disabled="disable"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="企业最终受益人证件起始日期"
                    label-width="150"
                  >
                    <el-input
                      v-model="item.enterpriseBeneficiaryIdCardValidStartDate"
                      :disabled="disable"
                      placeholder="如：20250101"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="企业最终受益人证件截止日期"
                    label-width="150"
                  >
                    <el-input
                      v-model="item.enterpriseBeneficiaryIdCardValidDate"
                      :disabled="disable"
                      placeholder="如：20250101"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="最终受益人联系地址" label-width="150">
                    <el-input
                      v-model="item.enterpriseBeneficiaryAddress"
                      :disabled="disable"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="最终受益人受益方式" label-width="150">
                    <el-select
                      v-model="item.enterpriseBeneficiaryIncomeType"
                      placeholder="请选择受益方式"
                      :disabled="disable"
                    >
                      <el-option
                        label="直接或间接控股25%（含）以上"
                        value="A01"
                      ></el-option>
                      <el-option
                        label="通过人事、财务等其他方式对公司进行控制"
                        value="A02"
                      ></el-option>
                      <el-option label="高级管理人员" value="A03"></el-option>
                      <el-option
                        label="法人或公司负责人"
                        value="A04"
                      ></el-option>
                      <el-option label="其他" value="A05"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div v-if="disable == false">
                  <el-button
                    type="primary"
                    @click="addInfo()"
                    style="margin: 0 auto 0"
                    >添加</el-button
                  >
                </div>
              </div>
              <div style="width: 40%">
                <div
                  v-for="(item, index) in form.enterpriseShareholderList"
                  :key="index"
                >
                  <div style="margin-bottom: 15px">
                    <span style="font-weight: 600; font-size: 20px"
                      >企业股东信息({{ index + 1 }})</span
                    >
                  </div>
                  <el-form-item label="企业控股股东名称" label-width="150">
                    <el-input
                      v-model="item.enterpriseShareholderName"
                      :disabled="disable"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="企业控股股东证件类型" label-width="150">
                    <el-select
                      v-model="item.enterpriseShareholderIdCardType"
                      placeholder="请选择证件类型"
                      :disabled="disable"
                    >
                      <el-option label="营业执照" value="A18"></el-option>
                      <el-option label="身份证" value="B01"></el-option>
                      <el-option label="护照" value="B04"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="企业控股股东证件号码" label-width="150">
                    <el-input
                      v-model="item.enterpriseShareholderIdCardNo"
                      :disabled="disable"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="企业控股股东证件起始日期"
                    label-width="150"
                  >
                    <el-input
                      v-model="item.enterpriseShareholderIdCardValidStartDate"
                      :disabled="disable"
                      placeholder="如：20250101"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="企业控股股东证件截止日期"
                    label-width="150"
                  >
                    <el-input
                      v-model="item.enterpriseShareholderIdCardValidDate"
                      :disabled="disable"
                      placeholder="如：20250101"
                    ></el-input>
                  </el-form-item>
                </div>
                <div v-if="disable == false">
                  <el-button
                    type="primary"
                    @click="addInfo1()"
                    style="margin: 0 auto 0"
                    >添加</el-button
                  >
                </div>
              </div>
            </div>
          </el-card>
          <el-card
            v-if="!disable"
            class="box-card"
            shadow="never"
            style="margin-top: 10px; text-align: center"
          >
            <el-form-item>
              <el-button
                type="primary"
                @click="onSubmit"
                style="margin: 0 auto 0"
                >提交开户</el-button
              >
            </el-form-item>
          </el-card>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import axiosUrl from "../../api/axios.js";
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.financeData(),
      form: {
        url: "",
        url1: "",
        url2: "",
        url3: "",
        url4: "",
        name: "",
        type: "A18",
        num: "",
        code: "",
        address: "",
        bankName: "",
        bankNum: "",
        bankNum1: "",
        balanceMark: "",
        balanceName: "",
        name1: "",
        type1: "",
        Idcard: "",
        phone: "",
        name2: "",
        type2: "",
        Idcard2: "",
        phone2: "",
        // name3: "",
        // type3: "",
        // Idcard3: "",
        // phone3: "",
        // time: "",
        // time1: "",
        // address1: "",
        // type4: "",
        enterpriseBeneficiaryInfos: [
          {
            enterpriseBeneficiaryName: "",
            enterpriseBeneficiaryIdCardType: "",
            enterpriseBeneficiaryIdCardNo: "",
            enterpriseBeneficiaryIdContactPhone: "",
            enterpriseBeneficiaryIdCardValidStartDate: "",
            enterpriseBeneficiaryIdCardValidDate: "",
            enterpriseBeneficiaryAddress: "",
            enterpriseBeneficiaryIncomeType: "",
          },
        ],
        // name4: "",
        // Idcard4: "",
        // time2: "",
        // time3: "",
        // type5: "",
        enterpriseShareholderList: [
          {
            enterpriseShareholderName: "",
            enterpriseShareholderIdCardType: "",
            enterpriseShareholderIdCardNo: "",
            enterpriseShareholderIdCardValidStartDate: "",
            enterpriseShareholderIdCardValidDate: "",
          },
        ],
      },
      disable: false,
      uploadUrl: "",
      deader: {
        "x-ba-admin-token": localStorage.getItem("TOKEN"),
      },
      editId: "",
      info: {},
      loading: false,
    };
  },
  mounted() {
    if (this.$route.query.id) {
      this.editId = this.$route.query.id;
      this.disable = true;
      this.getDetail();
    }
    this.uploadUrl = axiosUrl.defaults.baseURL + "admapi/sys/file/upload";
  },
  methods: {
    addInfo() {
      this.form.enterpriseBeneficiaryInfos.push({
        enterpriseBeneficiaryName: "",
        enterpriseBeneficiaryIdCardType: "",
        enterpriseBeneficiaryIdCardNo: "",
        enterpriseBeneficiaryIdContactPhone: "",
        enterpriseBeneficiaryIdCardValidStartDate: "",
        enterpriseBeneficiaryIdCardValidDate: "",
        enterpriseBeneficiaryAddress: "",
        enterpriseBeneficiaryIncomeType: "",
      });
    },
    addInfo1() {
      this.form.enterpriseShareholderList.push({
        enterpriseShareholderName: "",
        enterpriseShareholderIdCardType: "",
        enterpriseShareholderIdCardNo: "",
        enterpriseShareholderIdCardValidStartDate: "",
        enterpriseShareholderIdCardValidDate: "",
      });
    },
    onSubmit() {
      this.loading = true;
      let param = {
        memberType: "1",
        enterpriseLicenseUrl: this.form.url,
        accountName: this.form.balanceName,
        accountDesc: this.form.balanceMark,
        companyName: this.form.name,
        enterpriseLicenseName: this.form.type,
        enterpriseUnifiedCode: this.form.num,
        enterpriseTrade: this.form.code,
        enterpriseRealAddress: this.form.address,
        enterpriseBankName: this.form.bankName,
        enterpriseBankCode: this.form.bankNum,
        enterpriseBankCardNo: this.form.bankNum1,
        enterpriseLegalIdCardType: this.form.type1,
        enterpriseLegalName: this.form.name1,
        enterpriseLegalPhone: this.form.phone,
        enterpriseLegalIdCardNo: this.form.Idcard,
        enterpriseLegalIdCardFront: this.form.url1,
        enterpriseLegalIdCardBack: this.form.url2,
        enterpriseContactName: this.form.name2,
        enterpriseContactIdCardType: this.form.type2,
        enterpriseContactPhone: this.form.phone2,
        enterpriseContactIdCardNo: this.form.Idcard2,
        enterpriseContactIdCardFront: this.form.url3,
        enterpriseContactIdCardBack: this.form.url4,
        enterpriseBeneficiaryInfos: this.form.enterpriseBeneficiaryInfos,
        enterpriseShareholderList: this.form.enterpriseShareholderList,
      };

      this.$axios
        .post(`/admapi/innerAccount/companyIncoming`, param)
        .then(({ data }) => {
          this.$message.success("提交成功");
          this.$router.push({ path: "/balance" });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleAvatarSuccess(res, file) {
      this.form.url = res.data;
    },
    handleAvatarSuccess1(res, file) {
      this.form.url1 = res.data;
    },
    handleAvatarSuccess2(res, file) {
      this.form.url2 = res.data;
    },
    handleAvatarSuccess3(res, file) {
      this.form.url3 = res.data;
    },
    handleAvatarSuccess4(res, file) {
      this.form.url4 = res.data;
    },
    getDetail() {
      this.$axios
        .post(`/admapi/innerAccount/getInnerAccountDetail/${this.editId}`)
        .then(({ data }) => {
          this.info = data;
          this.form.url = data.companyInfo.businessLicense;
          this.form.name = data.companyInfo.companyName;
          // this.form.type = data.companyInfo;
          this.form.num = data.companyInfo.licenseNo;
          this.form.code = data.companyInfo.enterpriseTrade;
          this.form.address = data.companyInfo.enterpriseRealAddress;
          this.form.bankName = data.companyInfo.bankName;
          this.form.bankNum = data.companyInfo.bankAccountNo;
          this.form.bankNum1 = data.companyInfo.enterpriseBankCardNo;
          this.form.balanceName = data.accountName;
          this.form.balanceMark = data.accountDesc;
          this.form.url1 = JSON.parse(
            data.companyInfo.legalPerson
          ).cardPhotoFront;
          this.form.url2 = JSON.parse(
            data.companyInfo.legalPerson
          ).cardPhotoBack;
          this.form.name1 = JSON.parse(data.companyInfo.legalPerson).name;
          this.form.type1 = JSON.parse(data.companyInfo.legalPerson).cardType;
          this.form.Idcard = JSON.parse(data.companyInfo.legalPerson).cardNo;
          this.form.phone = JSON.parse(
            data.companyInfo.legalPerson
          ).contactInformation;
          this.form.url3 = JSON.parse(
            data.companyInfo.contactInfo
          ).cardPhotoFront;
          this.form.url4 = JSON.parse(
            data.companyInfo.contactInfo
          ).cardPhotoBack;
          this.form.name2 = JSON.parse(data.companyInfo.contactInfo).name;
          this.form.type2 = JSON.parse(data.companyInfo.contactInfo).cardType;
          this.form.Idcard2 = JSON.parse(data.companyInfo.contactInfo).cardNo;
          this.form.phone2 = JSON.parse(
            data.companyInfo.contactInfo
          ).contactInformation;
          this.form.enterpriseBeneficiaryInfos = JSON.parse(
            data.companyInfo.enterpriseBeneficiaryInfos
          );
          let arr = JSON.parse(data.companyInfo.enterpriseShareholderInfo);
          let arr1 = [];
          for (let i = 0; i < arr.length; i++) {
            arr1.push({
              enterpriseShareholderName: arr[i].enterpriseShareholderName,
              enterpriseShareholderIdCardType:
                arr[i].enterpriseShareholderIdCardType,
              enterpriseShareholderIdCardNo:
                arr[i].enterpriseShareholderIdCardNo,
              enterpriseShareholderIdCardValidStartDate:
                arr[i].enterpriseShareholderIdCardValidStartDate,
              enterpriseShareholderIdCardValidDate:
                arr[i].enterpriseShareholderIdCardValidDate,
            });
          }
          this.form.enterpriseShareholderList = arr1;
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.el-popover {
  padding: 0px 16px !important;
  box-sizing: border-box;
  border: none;
  min-width: 0;
}
</style>
